import Cell from "../gameUtil/Base/Cell";
import Reel from "../gameUtil/Base/Reel";
import FreeSpinReel from "../gameUtil/Free/FreeSpinReel";
import FreeSpinCell from "../gameUtil/Free/FreeSpinCell";
import FontConfig from "../config/FontConfig";
import Utils from "../utils/Utils";
import ResourcesDispatcher from "../config/ResourcesDispatcher";
import LinkReelVertical from "../gameUtil/Link/LinkReelVertical";
import LinkReelRotation from "../gameUtil/Link/LinkReelRotation";
import { LinkReel } from "..";
import ReelStatic from "../gameUtil/Base/ReelStatic";
import ReelDynamic from "../gameUtil/Base/ReelDynamic";
import FreeSpinReelStatic from "../gameUtil/Free/FreeSpinReelStatic";
import FreeSpinReelDynamic from "../gameUtil/Free/FreeSpinReelDynamic";
import { LayoutBuilder } from "../gameUtil/buildLayoutTree";

(window as any).isButtonSpinning = false;

export default class CreationManager{

    //CREAZIONE RULLI
    static createReels(scene: any, gameLogicVariableManager: any, gameDataManager: any, orientation: any, type: string, layoutTreeManager: LayoutBuilder): Reel[] {

        let reels: Reel[] = [];
        const reelsPosition = Utils.generateReelsPosition(
            ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_REELS, 
            ResourcesDispatcher.GAME_CONSTANTS.REEL_SIZE, 
            ResourcesDispatcher.GAME_CONSTANTS.GRID_BORDER.CENTER)

        let ReelClass: any;

        if(type === "static") {
            ReelClass = ReelStatic;
        } else if (type === "dynamic") {
            ReelClass = ReelDynamic;
        }

        for (let i = 0; i < ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_REELS; i++) {
            const reel = new ReelClass(scene, reelsPosition[i].x, reelsPosition[i].y, i, gameLogicVariableManager, gameDataManager, orientation, layoutTreeManager);
            reels.push(reel);
            // Aggiungi i rulli ai container corretti
            // scene.layerManager.gameAreaLayer.baseSymbolsContainer.add(reel.getContainer());
            // scene.layerManager.gameAreaLayer.overGridContainer.add(reel.getAnimationsContainer());
        }

        return reels;
    }

    //CREAZIONE CELLE
    static createCells(scene: any, gameLogicVariableManager: any, reelAssociate: any, container: any, layoutBuilder: LayoutBuilder) : { cells: Cell[]; cellPositions: any[] } {
        
        const cells: Cell[] = [];
        const numOfCells = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL + ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_CELLS_PER_REEL;
        const cellsPosition = [];

        for (let i = 0; i < numOfCells; i++) {
            const cell = new Cell(scene, gameLogicVariableManager, 0, 0, i, reelAssociate, layoutBuilder);
            cells.push(cell);
            // TODO: change "landscape" with orientation variable
            let cellDisplayListNode = layoutBuilder.getNodeByPath(`Basegame/grid/reel_${reelAssociate.getIndex()}/cell_${i}`, 'landscape');
            if(cellDisplayListNode){
                cellsPosition.push({x: cellDisplayListNode.coordinates.relative_top_left_to_parent?.x || 0, y: cellDisplayListNode.coordinates.relative_top_left_to_parent?.y || 0});
            } else {
                cellsPosition.push({x: cell.getContainer().x, y: cell.getContainer().y});
            }
            // container.add(cell.getContainer());
        }

        return {cells: cells, cellPositions: cellsPosition};
    }

    //CREAZIONE RULLI LINK
    static createLinkReels(scene: any, gameLogicVariableManager: any, gameDataManager: any, orientation: any, type: string) : LinkReel[]{
        
        let linkReels: LinkReel[] = [];
        let ReelClass: any;

        if(type === "vertical") {
            ReelClass = LinkReelVertical;
        } else if (type === "rotation") {
            ReelClass = LinkReelRotation;
        }

        for (let i = 0; i < ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_REELS; i++) {
            linkReels[i] = new ReelClass(scene, ResourcesDispatcher.GAME_CONSTANTS.linkReelsPosition[i].x, 
            ResourcesDispatcher.GAME_CONSTANTS.linkReelsPosition[i].y, i, gameLogicVariableManager, gameDataManager, orientation);

            scene.layerManager.gameAreaLayer.linkSymbolsContainer.add(linkReels[i].getContainer());
            scene.layerManager.gameAreaLayer.linkFrameContainer.add(linkReels[i].getFrameContainer());
            scene.layerManager.gameAreaLayer.fixedLinkCellContainer.add(linkReels[i].getAnimationsContainer());
        }

        return linkReels;
    }

    //CREAZIONE RULLI FREESPIN
    static createFreeSpinReels(scene: any, gameLogicVariableManager: any, gameDataManager: any, orientation: any, type: string, layoutBuilder: LayoutBuilder): FreeSpinReel[] {

        let numOfReels = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_REELS;
        let reels: FreeSpinReel[] = [];

        let FreeSpinReelClass: any;

        if(type === "static") {
            FreeSpinReelClass = FreeSpinReelStatic;
        } else if (type === "dynamic") {
            FreeSpinReelClass = FreeSpinReelDynamic;
        }

        const reelsPosition = Utils.generateReelsPosition(numOfReels, ResourcesDispatcher.GAME_CONSTANTS.REEL_SIZE, ResourcesDispatcher.GAME_CONSTANTS.GRID_BORDER.CENTER)

        for (let i = 0; i < numOfReels; i++) {

            const freeSpinCellCreation = CreationManager.createFreeSpinCells(scene, gameLogicVariableManager, i, layoutBuilder);

            const reel = new FreeSpinReelClass(scene, reelsPosition[i].x, reelsPosition[i].y, i, gameLogicVariableManager, gameDataManager, orientation, layoutBuilder, freeSpinCellCreation);

            freeSpinCellCreation.cells.forEach((cell) => {
                cell.setFreeSpinReel(reel);
            });

            reels.push(reel);
        }

        return reels;
    }

    //CREAZIONE CELLE FREESPIN
    static createFreeSpinCells(scene: any, gameLogicVariableManager: any, reelIndex: number, layoutBuilder: LayoutBuilder) : { cells: FreeSpinCell[]; cellPositions: any[] } {

        const cells: FreeSpinCell[] = [];
        const numOfCells = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL + ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_CELLS_PER_REEL;
        const cellsPosition = [];
        
        for (let i = 0; i < numOfCells; i++) {
            const cell = new FreeSpinCell(scene, gameLogicVariableManager, 0, 0, i, reelIndex, layoutBuilder);
            cells.push(cell);
            // TODO: change "landscape" with orientation variable
            let cellDisplayListNode = layoutBuilder.getNodeByPath(`FreeSpin/grid/reel_${reelIndex}/cell_${i}`, 'landscape');
            if(cellDisplayListNode){
                cellsPosition.push({x: cellDisplayListNode.coordinates.relative_top_left_to_parent?.x, y: cellDisplayListNode.coordinates.relative_top_left_to_parent?.y});
            } else {
                cellsPosition.push({x: cell.getContainer().x, y: cell.getContainer().y});
            }
            // container.add(cell.getContainer());
        }
        return {cells: cells, cellPositions: cellsPosition};
    }

    //CREAZIONE EXPANDING WILD
    static createExpandingWild(scene: any, gameLogicVariableManager: any, cellPosition: any[], index: number, reelAssociate: Reel, layoutBuilder: LayoutBuilder) : Cell{
        const expanding = new Cell(scene, gameLogicVariableManager, cellPosition[index].x, cellPosition[index].y, index, reelAssociate, layoutBuilder)
        expanding.getContainer().setVisible(false);
        expanding.setCellInfo(ResourcesDispatcher.GAME_CONSTANTS.S_EXTRA_WILD)
        return expanding;
    }

    //CREAZIONE FONT
    static createFont(fontFamily: string){
        return new FontConfig(fontFamily);
    }
}